import React from 'react';
import Symbol from '@wikom/react-symbol';
import Layout from '../layout/Layout';
var Wartung = function () { return (React.createElement(Layout, null,
    React.createElement("div", { className: "alert alert-danger alert--sysnotice" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-2 text-center" },
                React.createElement(Symbol, { symbol: "ban" })),
            React.createElement("div", { className: "col-md-10" },
                React.createElement("h2", null, "Diese Seite befindet sich zur Zeit im Wartungs-Modus."),
                React.createElement("p", null, "Bitte versuchen Sie es zu einem sp\u00E4teren Zeitpunkt erneut.")))))); };
export default Wartung;
